import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { AppConfigService } from './services/app-config.service';

@Injectable()
export class MyInterceptor implements HttpInterceptor {
  constructor(private router: Router, private appConfig: AppConfigService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const router = this.router;

    req = this.trySetToken(req);

    return next.handle(req).do(
      (evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          if (evt.body.http_status) {
            evt.body.http_status = evt.status;
          }
        }
      },
      (error: any) => {
        if (error instanceof HttpErrorResponse) {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          if (error.status === 401) {
            // if (err.name === 'TokenExpiredError') {
            localStorage.setItem('loggedIn', 'false');
            router.navigate(['/login-cognito', {}], {});
            // }
          } else {
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
          }
        } else {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error);
        }
      }
    );
  }

  trySetToken(req: HttpRequest<any>): HttpRequest<any> {
    let token: string;
    // B2C
    if (this.appConfig.isB2cEnabled() || req.url.includes("/api/UserEntitlements")) {
      token = localStorage.getItem('b2c_access_token');
    }
    else {
      token = localStorage.getItem('token');
    }

    if (token) {
      req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
    }
    return req;
  }
}